import { render, staticRenderFns } from "./salesCollection.vue?vue&type=template&id=1e760a01"
import script from "./salesCollection.vue?vue&type=script&lang=js"
export * from "./salesCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports